// Remove classname 'prevent-transitions' from 'body' after DOM content is loaded
document.addEventListener("DOMContentLoaded", function () {
    let nodes = document.querySelectorAll('.prevent-transitions');
    nodes.forEach(node => {
        node.classList.remove('prevent-transitions');
    });
});